module.exports = __webpack_public_path__ + "img/title-ja.28def546.png";